import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { getChannel } from 'utils';

export default () => {
  const { key: channelKey, domain } = getChannel();
  const { t } = useTranslation('channels', {
    keyPrefix: `${channelKey}.meta`,
  });
  const theme = useTheme();
  const publicUrl = `${process.env.PUBLIC_URL || ''}/${channelKey}`;

  const title = t('title');
  const description = t('description');

  const socialSharingImg =
    'https://assets.unmind.com/image/upload/v1680014033/Personal%20Wellbeing/Thumbnails/social-sharing-image.png';

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />

      {/* Facebook tags */}
      <meta property="og:url" content={`https://${domain}`} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {channelKey === 'unmind' ? (
        <meta property="og:image" content={socialSharingImg} />
      ) : null}

      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content={domain} />
      <meta property="twitter:url" content={`https://${domain}`} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {channelKey === 'unmind' ? (
        <meta name="twitter:image" content={socialSharingImg} />
      ) : null}

      {/* Icons and colours */}
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${publicUrl}/apple-touch-icon.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${publicUrl}/favicon-32x32.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${publicUrl}/favicon-16x16.png`}
      />
      <link
        rel="mask-icon"
        href={`${publicUrl}/safari-pinned-tab.svg`}
        color={theme.colors.meta.icon}
      />
      <meta name="msapplication-TileColor" content={theme.colors.meta.tile} />
      <meta name="theme-color" content={theme.colors.meta.theme} />
      <link rel="manifest" href={`${publicUrl}/manifest.json`} />
    </Helmet>
  );
};
